import styled from "styled-components/native";
import { pickStyle as _, pickThemeKey as theme } from "utils";
import {
  FeedbackButtonWidth,
  ListTextFontWeight,
  ListTextFontSize,
  ContainerWidth,
} from "./variables";

export const Container = styled.View`
  align-items: center;
`;

export const ListContainer = styled.View`
  margin: 40px auto 0px auto;
  width: ${_(ContainerWidth) || "100%"};
  align-items: center;
`;

export const ListItem = styled.TouchableOpacity`
  width: ${_(FeedbackButtonWidth) || "calc((100% / 3) - 30px)"};
  height: 40px;
  border-radius: 8px;
  padding: 22px 12px;
  background-color: ${props =>
    props.$isSelected
      ? theme("image_background_selected")(props)
      : theme("image_background")(props)};
  margin-bottom: 20px;
  justify-content: center;
  align-items: center;
  box-shadow: #0000001a 0px 3px 5px;
  border: 3px
    ${props =>
      props.$isSelected
        ? theme("image_text_selected")(props)
        : theme("image_background")(props)};
`;

export const ListText = styled.Text`
  color: ${props =>
    props.$isSelected
      ? theme("image_text_selected")(props)
      : theme("image_text")(props)};
  font-size: ${_(ListTextFontSize) || 18}px;
  font-weight: ${_(ListTextFontWeight) || 200};
`;
